module.exports = __webpack_public_path__ + "img/GrüneSchaukel.e11864d6.jpg";